export default {
    methods: {
        scrollTop() {
            this.getSimplebar().getScrollElement().scrollTop = 0
        },

        getSimplebar() {
            const simplebarEl = this.$el.closest('[data-simplebar]')
            return simplebarEl ? simplebarEl.SimpleBar : undefined
        },
    },
}
